import { CommonModule } from '@angular/common';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'alert-message',
    imports:[CommonModule, MatIconModule, MatDialogModule, MatFormFieldModule],
    template:`
        <div class="flex flex-auto w-full flex-col items-center p-4 sm:flex-row sm:items-start">
            <div class="flex h-10 w-10 flex-0 items-center justify-center rounded-full sm:mr-4 bg-blue-100 text-blue-600 dark:bg-blue-600 dark:text-blue-50'">
                <mat-icon class="text-current" svgIcon="heroicons_outline:exclamation-triangle"></mat-icon>
            </div>
            <div class="w-full flex flex-col items-center space-y-1 text-center sm:mt-0 sm:items-start sm:pr-8 sm:text-left">
                <h2 class="text-xl font-bold">{{title}}</h2>
                <mat-dialog-content class="p-0 w-full">
                <div class="w-full">
                        <span class="">{{message}}</span>
                </div>
                </mat-dialog-content>
            </div>
        </div>
    `
})

export class AlertMessageComponent implements OnInit {
    title:string
    message:string

    constructor( 
        public dialogRef: MatDialogRef<AlertMessageComponent>,
        @Inject(MAT_DIALOG_DATA) public data:{
        title: string,
        message: string
    } ) { 
        this.title = this.data.title
        this.message = this.data.message
    }

    ngOnInit() { }
}